import type { RowSelectionStore } from "@/components/data-table/context/RowSelectionContext";
import { useSyncExternalStore } from "react";

/** Stable string that changes when the selection set changes (for `dataMapper` deps). */
export function useSelectionRevisionFromStore(store: RowSelectionStore) {
  return useSyncExternalStore(
    store.subscribe,
    () => [...store.getSelection()].sort().join(","),
    () => "",
  );
}
